import { SDK } from '../index';
import {
    OptionPoll,
    OptionPollAnswerInput,
    OptionPollAnswerMutationVariables,
    OptionPollsQueryVariables,
    ProfileOptionPoll,
    ResultSuccess,
} from '../generated/graphql';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';

export const optionPollAnswer = async (
    data: OptionPollAnswerInput,
    sdk: SDK,
): Promise<ProfileOptionPoll | ResultSuccess> => {
    const mutation = require('../graphql/mutations/optionPollAnswer.mutation.gql');
    return sdk.mutate<
        {
            optionPollAnswer: ProfileOptionPoll;
        },
        OptionPollAnswerMutationVariables
    >(
        {
            mutation: mutation,
            variables: { o_Data: data },
        },
        'optionPollAnswer',
    );
};

export const optionPolls = async (
    sdk: SDK,
    fetchPolicy: FetchPolicy = 'cache-first',
): Promise<Array<OptionPoll> | ResultSuccess> => {
    const query = require('../graphql/queries/optionPolls.query.gql');
    return sdk.query<
        {
            findManyOptionPoll: Array<OptionPoll>;
        },
        OptionPollsQueryVariables
    >(
        {
            query: query,
            fetchPolicy,
        },
        'findManyOptionPoll',
    );
};
